import { IChartData } from "@/interfaces/dashboard.interface";
import { BarChart, Bar, ResponsiveContainer, Tooltip } from "recharts";
import { Skeleton } from "../ui/skeleton";

interface BarChartCardProps {
  title: string;
  data: IChartData[];
  percentage: number;
  period: string;
  isLoading?: boolean;
}

export default function BarChartCard({ title, data, percentage, period, isLoading }: BarChartCardProps) {
  const isPositive = percentage >= 0;

  return (
    <div className="bg-darkblue rounded-[20px] p-[30px] w-full lg:w-[428px] h-[227px] flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-semibold text-[#F6F6F6]">{title}</h3>
          <div className="bg-[#0C1427] rounded-[20px] px-[10px] py-1">
            <p className={`text-xs ${isPositive ? 'text-[#13D480]' : 'text-[#DC4426]'}`}>
              {isPositive ? '+' : ''}{percentage}%
            </p>
          </div>
        </div>
        <p className="text-xs text-[#888888]">{period}</p>
      </div>

      {/* Value */}
      <p className="text-xl font-bold text-white mb-4">
        R${data.reduce((sum, item) => sum + item.value1, 0).toLocaleString('pt-BR')}
      </p>

      {/* Chart */}
      <div className="flex-1 min-h-[100px]">
        {isLoading ? (
          <Skeleton className="h-full" />
        ) : data.length === 0 ? (
          <div className="flex items-center justify-center h-full text-gray-400 text-sm">
            Sem dados disponíveis
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%" minHeight={100}>
            <BarChart data={data} barGap={5} barCategoryGap={32}>
              <Tooltip
                contentStyle={{
                  backgroundColor: "#15203C",
                  border: "1px solid #5D5D5D",
                  borderRadius: "8px",
                }}
                labelStyle={{ color: "#F6F6F6" }}
                itemStyle={{ color: "#F6F6F6" }}
              />
              <Bar dataKey="value1" fill="#7846FF" radius={[4, 4, 0, 0]} barSize={23} />
              <Bar dataKey="value2" fill="#45169C" radius={[4, 4, 0, 0]} barSize={23} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>

      {/* Legend */}
      <div className="flex items-center gap-6 mt-3">
        <div className="flex items-center gap-[10px]">
          <div className="size-[7px] rounded-full bg-[#7846FF]" />
          <p className="text-xs text-white">Completos</p>
        </div>
        <div className="flex items-center gap-[10px]">
          <div className="size-[7px] rounded-full bg-[#45169C]" />
          <p className="text-xs text-white">Pendentes</p>
        </div>
      </div>
    </div>
  );
}
